module.exports = __webpack_public_path__ + "img/qilin-f-stage6-hungry.5ae04bc2.png";